/**
 * @generated SignedSource<<edb34cc521024bb2ec4c8ac6862669dc>>
 * @relayHash 370782061cad5b018a7abb99340247cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5de0f70aba791c6859f3a88d7e11961699651b6e643b08c9b5dd24567157c729

import type { ConcreteRequest } from 'relay-runtime';
export type EditorContentStateComponentRemoveContentStateMutation$variables = {
  contentId: string;
};
export type EditorContentStateComponentRemoveContentStateMutation$data = {
  readonly removeContentState: boolean | null;
};
export type EditorContentStateComponentRemoveContentStateMutation = {
  response: EditorContentStateComponentRemoveContentStateMutation$data;
  variables: EditorContentStateComponentRemoveContentStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "kind": "ScalarField",
    "name": "removeContentState"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorContentStateComponentRemoveContentStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorContentStateComponentRemoveContentStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "370782061cad5b018a7abb99340247cc",
    "id": "5de0f70aba791c6859f3a88d7e11961699651b6e643b08c9b5dd24567157c729",
    "metadata": {},
    "name": "EditorContentStateComponentRemoveContentStateMutation",
    "operationKind": "mutation",
    "text": "mutation EditorContentStateComponentRemoveContentStateMutation($contentId:ID!){removeContentState(contentId:$contentId)}"
  }
};
})();

(node as any).hash = "239fd93c05e6cc0bc826fd776d1a8efd";

export default node;
